import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'app/auth-guard.service';

import { FilesComponent } from './files/files.component';
import { SharingComponent } from './sharing/sharing.component';
import { CorporateComponent } from './corporate/corporate.component';
import { ViewerComponent } from './viewer/viewer.component';
import { SearchComponent } from './search/search.component';
import { TrashComponent } from './trash/trash.component';
import { SharedLinkComponent } from './share-link/share-link.component';
import { SharedByMeComponent } from './share-by-me/share-by-me.component';
import { SharedWithMeComponent } from './share-with-me/share-with-me.component';
import { ViewShareComponent } from './view-share/view-share.component';
import { CallbackComponent } from './onedrive/callback.component';
import { TaxReportComponent } from './report/tax-report.component';
import {CanDeactivateGuard} from '../candeactivate-guard.service';
import { EtaxSharedComponent } from './etax-shared/etax-shared.component';
import { GoogleDrivePageComponent } from './google-drive-page/google-drive-page.component';
import { GoogleDriveViewerComponent } from './google-drive-viewer/google-drive-viewer.component';
import { ViewSharePublicComponent } from './view-share-public/view-share-public.component';
import { ShareViewerComponent } from './view-share-public/share-viewer/share-viewer.component';
import { CallbackDropboxComponent } from './dropbox/callback-dropbox.component';
import { OneDrivePageComponent } from './onedrive-page/onedrive-page.component';
import { OneDriveAuthGuardService as OneDriveAuthGuard } from './onedrive/onedrive-auth-guard.service';
import { UserCompanyComponent } from 'app/admin/user-company/user-company.component';
import { OnedriveViewerComponent } from './onedrive-viewer/onedrive-viewer.component';
import { GoogledriveAuthGuardService as GoogleDriveAuthGuard } from "./google-drive/googledrive-auth-guard.service";
import { DropboxPageComponent } from './dropbox-page/dropbox-page.component';
import { DropboxAuthGuardService as DropboxAuthGuard } from "./dropbox/dropbox-auth-guard.service";
import { DropboxViewerComponent } from './dropbox-viewer/dropbox-viewer.component';

const routes: Routes = [
   {
      path: 'files',
      redirectTo: 'files/',
      pathMatch: 'full'
   },
   {
      path: 'files',
      children: [
         {
            path: '',
            component: FilesComponent,
            canActivate: [AuthGuard]
         },
         {
            path: '**',
            component: FilesComponent,
            canActivate: [AuthGuard]
         }
      ]
   },
   {
      path: 'sharing',
      component: SharingComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'work',
      children: [
         {
            path: '',
            component: CorporateComponent,
            canActivate: [AuthGuard]
         },
         {
            path: '**',
            component: CorporateComponent,
            canActivate: [AuthGuard]
         }
      ]
   },
   {
      path: 'googleDrivePage',
      redirectTo: 'googleDrivePage/',
      pathMatch: 'full'
   },
   {
      path: 'googleDrivePage',
      children: [
         {
            path: '',
            component: GoogleDrivePageComponent,
            canActivate: [AuthGuard, GoogleDriveAuthGuard]
         },
         {
            path: '**',
            component: GoogleDrivePageComponent,
            canActivate: [AuthGuard, GoogleDriveAuthGuard]
         }
      ]
   },
   {
      path: 'onedrivepage',
      redirectTo: 'onedrivepage/',
      pathMatch: 'full'
   },
   {
      path: 'onedrivepage/:id',
      children: [
         {
            path: '',
            component: OneDrivePageComponent,
            canActivate: [AuthGuard, OneDriveAuthGuard]
         },
         {
            path: '**',
            component: OneDrivePageComponent,
            canActivate: [AuthGuard, OneDriveAuthGuard]
         }
      ]
   },
   {
      path: 'dropboxPage',
      redirectTo: 'dropboxPage/',
      pathMatch: 'full'
   },
   {
      path: 'dropboxPage',
      children: [
         {
            path: '',
            component: DropboxPageComponent,
            canActivate: [AuthGuard, DropboxAuthGuard]
         },
         {
            path: '**',
            component: DropboxPageComponent,
            canActivate: [AuthGuard, DropboxAuthGuard]
         }
      ]
   },
   {
      path: 'file/:id',
      component: ViewerComponent,
      canActivate: [AuthGuard],
      canDeactivate: [CanDeactivateGuard]
   },
   {
      path: 'sharefile/:id',
      component: ShareViewerComponent
   },
   {
      path: 'GoogleDriveViewer',
      component: GoogleDriveViewerComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'OneDriveViewer/:driveitem',
      component: OnedriveViewerComponent,
      canActivate: [AuthGuard, OneDriveAuthGuard]
   },
   {
      path: 'DropboxViewer',
      component: DropboxViewerComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'search',
      component: SearchComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'trash',
      component: TrashComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'share/:shareId',
      children: [
         {
            path: '',
            component: ViewShareComponent
         },
         {
            path: '**',
            component: ViewShareComponent
         }
      ]
   },
   {
      path: 'share-public/:shareId',
      children: [
         {
            path: '',
            component: ViewSharePublicComponent
         },
         {
            path: '**',
            component: ViewSharePublicComponent
         }
      ]
   },
   {
      path: 'sharedbyme',
      children: [
         {
            path: '',
            component: SharedByMeComponent,
            canActivate: [AuthGuard]
         },
         {
            path: '**',
            component: SharedByMeComponent,
            canActivate: [AuthGuard]
         }
      ]
   },
   {
      path: 'sharedwithme',
      children: [
         {
            path: '',
            component: SharedWithMeComponent,
            canActivate: [AuthGuard]
         },
         {
            path: '**',
            component: SharedWithMeComponent,
            canActivate: [AuthGuard]
         }
      ]
   },
   {
      path: 'sharedlink',
      component: SharedLinkComponent
   },
   {
      path: 'callback',
      component: CallbackComponent
   },
   {
      path: 'callback-dropbox',
      component: CallbackDropboxComponent
   },
   {
      path: 'report/:tin/:type/:year/:month',
      component: TaxReportComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'etax/:shareId',
      component: EtaxSharedComponent
   },
   {
      path: 'admin-tool/company-user',
      component: UserCompanyComponent
   },
];

@NgModule({
   imports: [RouterModule.forRoot(routes)],
   exports: [RouterModule]
})
export class DmsRoutingModule { }
